module.exports = __webpack_public_path__ + "static/media/all-activities-active.ef5a4283.svg";